import axios from "../api/axios";

/**
 * Crée une session Stripe Checkout via ton backend,
 * et renvoie les données pour les utiliser dans ton flux (ex: envoi email)
 */
export const createCheckoutSession = async (payload: {
  amount: number; // Montant en centimes
  currency: string;
  returnUrl: string;
  description?: string;
}) => {
  try {
    const { data } = await axios.post("/stripe/payment-session", payload);

    if (!data?.paymentSession) {
      throw new Error("Aucune session Stripe retournée par le backend.");
    }

    return data.paymentSession; // contient id, url, status, etc.
  } catch (err: any) {
    console.error("[StripeService] createCheckoutSession error:", err.message);
    throw err;
  }
};

/**
 * Vérifie le statut d’une session Stripe Checkout
 */
export const getCheckoutSession = async (sessionId: string) => {
  try {
    const { data } = await axios.get(`/stripe/payment-session/${sessionId}`);
    return data;
  } catch (err: any) {
    console.error("[StripeService] getCheckoutSession error:", err.message);
    throw err;
  }
};